Router = App.loadClass 'core::Router'
Storage = App.loadClass 'core::Storage'

class exports.PlantingRxRouter extends Router

    prefix: 'PlantingRx'
    module_name: 'PlantingRxRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        dir = App.load 'grower::Angular/Data/PlantingRx/Directives/rxPlantingRow'
        dir.register(@module)

        @service 'grower::Angular/Data/PlantingRx/Services/SeedCompaniesService', ['$http', '$rootScope']
        @service 'grower::Angular/Data/PlantingRx/Services/ProductsService', ['$http', '$rootScope']
        @service 'grower::Angular/Data/PlantingRx/Services/MachineryService', ['$http', '$rootScope']
        @service 'grower::Angular/Data/PlantingRx/Services/PlantingRxService', ['$http', '$rootScope']
        @service 'grower::Angular/Data/PlantingRx/Services/VisualLayersService', ['$http', '$rootScope', '$q']
        @service 'grower::Angular/Data/PlantingRx/Services/LegendService', ['$rootScope']

        @controller 'grower::Angular/Data/PlantingRx/SidebarController', [
            '$scope', '$transitions'
            '$state'
            'PlantingRx.Services.MachineryService'
            'RxOptions'
            'PlantingRx.Services.PlantingRxService'
            'Core.Services.Map'
            'Core.Services.MapLayers.Manager'
            'Grower.Services.TruthStripToolbar'
            'Core.Services.Loading'
        ]

        @controller 'grower::Angular/Data/PlantingRx/ProductPlanterController', [
            '$scope', '$transitions'
            'PlantingRx.Services.PlantingRxService'
            '$q'
            'PlantingRx.Services.SeedCompaniesService'
            'PlantingRx.Services.ProductsService'
        ]

        @controller 'grower::Angular/Data/PlantingRx/LayersController', [
            '$scope', '$transitions'
            'Core.Services.Map'
            'PlantingRx.Services.VisualLayersService'
            'Core.Services.MapLayers.Manager'
            'Core.Services.Loading'
        ]

        @controller 'grower::Angular/Data/PlantingRx/TruthStripsController', [
            '$scope', '$transitions'
            'Core.Services.Map'
            'PlantingRx.Services.VisualLayersService'
            'Core.Services.MapLayers.Manager'
            'Grower.Services.TruthStripToolbar'
            'Core.Services.Loading'
        ]

        @controller 'grower::Angular/Data/PlantingRx/PrescriptionController', [
            '$scope', '$transitions'
            'Core.Services.Map'
            '$state'
            'PlantingRx.Services.PlantingRxService'
            'PlantingRx.Services.VisualLayersService'
            'Core.Services.MapLayers.Manager'
            'Core.Services.Loading'
            'PlantingRx.Services.LegendService'
        ]

        @controller 'grower::Angular/Data/PlantingRx/TableViewController', [
            '$scope', '$transitions'
            'PlantingRx.Services.PlantingRxService'
        ]

    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'grower.planting-rx',
                url: '/planting-rx/{id}'
                templateUrl: 'backend/grower/layers/planting-rx/ng-sidebar'
                resolve: {
                    RxOptions: () ->
                        if window.RxStorage?
                            store = window.RxStorage
                            window.RxStorage = null
                        else
                            store = new Storage()

                        return store

                }
                controller: 'PlantingRx.Controllers.SidebarController'
            .state 'grower.planting-rx.products',
                url: ''
                views:
                    'fullpage':
                        templateUrl: 'backend/grower/layers/planting-rx/ng-product-planter'
                        controller: 'PlantingRx.Controllers.ProductPlanterController'
            .state 'grower.planting-rx.layers',
                url: ''
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/layers/planting-rx/ng-layers'
                        controller: 'PlantingRx.Controllers.LayersController'
            .state 'grower.planting-rx.truth-strips',
                url: ''
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/layers/planting-rx/ng-truthstrips'
                        controller: 'PlantingRx.Controllers.TruthStripsController'
            .state 'grower.planting-rx.prescription',
                url: ''
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/layers/planting-rx/ng-prescription'
                        controller: 'PlantingRx.Controllers.PrescriptionController'
            .state 'grower.planting-rx.prescription.table',
                url: ''
                views:
                    # Okay, so this looks weird, right? Well, get this: ui-router looks for
                    # ui-views CONTEXTUALLY. It looks within the direct parent of a state for
                    # the named ui-view. Since this is a nested state (it's inside of the prescription
                    # state), "fullpage" is not found. BUT, you can tell ui-router what context to
                    # search for ui-views in. So, here, I tell it to search for "fullpage" in the context
                    # of the "planting-rx" state (which is the one that loads the base dom structure),
                    # including the sidebar-step and fullpage areas.
                    'fullpage@grower.planting-rx':
                        templateUrl: 'backend/grower/layers/planting-rx/ng-table'
                        controller: 'PlantingRx.Controllers.TableViewController'
